/*
 * @Autor: Baowang
 * @Date: 2023-07-03 17:39:29
 * @pageName: 配置域名文件
 * @LastEditTime: 2024-11-18 17:32:40
 */
export default {
	// HOST:"https://jyvideo.yunqizhongguo.com", // 公司
	HOST:"https://www.morethanart.cn", // 客户
	// HOST: "/index.php", // 线上同源部署，避免跨域
	// HOST: "http://127.0.0.1:8000/index.php", // 本地联调
}
